import { Product } from 'graphql-api/gql-api-interfaces';

import { TotalCountPerAvailability } from '../interfaces';

export const countTotalProductsPerAvailability = <T extends Partial<Product>[]>(
  products: T,
) =>
  products.reduce(
    (totalCollection: TotalCountPerAvailability, product) => {
      if (product.isAvailable ?? true) totalCollection.available += 1;
      else totalCollection.unavailable += 1;

      return totalCollection;
    },
    { available: 0, unavailable: 0 },
  );
